var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDireito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1294",
    d: "M58.0796 28.4517C58.0796 43.7166 45.705 56.0912 30.4412 56.0912C15.1762 56.0912 2.80273 43.7166 2.80273 28.4517C2.80273 13.1878 15.1762 0.813232 30.4412 0.813232C45.705 0.813232 58.0796 13.1878 58.0796 28.4517Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1295",
    d: "M42.2051 15.5754C42.2051 22.0727 36.9374 27.3392 30.4413 27.3392C23.944 27.3392 18.6775 22.0727 18.6775 15.5754C18.6775 9.07926 23.944 3.81274 30.4413 3.81274C36.9374 3.81274 42.2051 9.07926 42.2051 15.5754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 897"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 102",
    x: 29.554,
    y: 12.5557,
    width: 1.73238,
    height: 43.794,
    fill: "#2C353D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 103",
    x: 27.5701,
    y: 51.7397,
    width: 5.69956,
    height: 3.44792,
    fill: "#2C353D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 104",
    x: 50.8691,
    y: 11.8499,
    width: 1.11245,
    height: 41.489,
    transform: "rotate(90 50.8691 11.8499)",
    fill: "#2C353D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 105",
    x: 14.1726,
    y: 56.1907,
    width: 32.4953,
    height: 3.22918,
    fill: "#353F49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 106",
    x: 26.3555,
    y: 53.9104,
    width: 8.12898,
    height: 3.44792,
    fill: "#353F49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 107",
    x: 27.5911,
    y: 11.1499,
    width: 5.69967,
    height: 3.44792,
    fill: "#353F49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 108",
    x: 15.7427,
    y: 56.946,
    width: 15.2999,
    height: 0.67,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 109",
    x: 28.4592,
    y: 11.761,
    width: 3.37797,
    height: 0.755285,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1296",
    d: "M17.5592 31.9823L8.54657 14.8185L0.569217 31.9707L0.0737305 31.7407L8.51654 13.5867L18.0429 31.7285L17.5592 31.9823Z",
    fill: "#353F49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1297",
    d: "M0 31.6628C1.15681 36.9669 4.99125 38.9586 9.06115 38.9586C13.1299 38.9586 16.4513 36.8384 18.1223 31.6628H0Z",
    fill: "#92E0EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1298",
    d: "M8.96436 38.9564C8.99734 38.9564 9.02919 38.9586 9.06104 38.9586C13.1309 38.9586 16.4512 36.8384 18.1222 31.6628H8.96436V38.9564Z",
    fill: "#77D0DE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 110",
    x: 7.11426,
    y: 11.4431,
    width: 2.70208,
    height: 2.54317,
    fill: "#353F49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 111",
    x: 7.47192,
    y: 11.9202,
    width: 1.58963,
    height: 0.67,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1299",
    d: "M60.3194 31.9823L51.3067 14.8185L43.3299 31.9707L42.834 31.7407L51.2768 13.5867L60.8032 31.7285L60.3194 31.9823Z",
    fill: "#353F49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1300",
    d: "M42.76 31.6628C43.918 36.9669 47.7513 38.9586 51.8212 38.9586C55.8911 38.9586 59.2125 36.8384 60.8823 31.6628H42.76Z",
    fill: "#92E0EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1301",
    d: "M51.7256 38.9564C51.7574 38.9564 51.7893 38.9586 51.8211 38.9586C55.891 38.9586 59.2125 36.8384 60.8823 31.6628H51.7256V38.9564Z",
    fill: "#77D0DE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 112",
    x: 49.8748,
    y: 11.4431,
    width: 2.70253,
    height: 2.54317,
    fill: "#353F49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 113",
    x: 50.2324,
    y: 11.9202,
    width: 1.58963,
    height: 0.67,
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDireito);
export default __webpack_public_path__ + "static/media/direito.3d7110a4a70ed47aafd50d63b003e9e9.svg";
export { ForwardRef as ReactComponent };